<template>
  <div>
    <b-card class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">
            Responder a comunicação eletrônica
          </span>
          <btn-voltar url="/processo-eletronico/comunicacoes-eletronicas" />
          <b-button class="float-right m-1" size="sm" :disabled="Boolean(desabilitarBtnCadastrar)"
            @click="abrirModalAssinatura()">
            <font-awesome-icon icon="save" />
            Cadastrar
          </b-button>
          <b-button class="float-right m-1" size="sm" :disabled="isRascunhoEmpty()" @click="perguntarLimparRascunho()">
            <font-awesome-icon icon="times" />
            Descartar
          </b-button>
        </h6>
      </template>
      <b-container fluid class="p-0">
        <b-tabs card>
          <b-tab title="Dados do protocolo" active>
            <dados-comunicacao-eletronica :notificacao="notificacao" :responsavel="responsavel"
              :tipoDocSelecionado="tipoDocSelecionado" />
            <b-row>
              <b-col xs="12" md="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                <b-form-group class="formGroup" id="assunto-textarea-group" label="Assunto *"
                  label-for="textarea-Assunto" label-cols="auto" content-cols="12" v-if="rascunho">
                  <b-form-textarea v-if="rascunho" id="textarea-Assunto" v-model="assunto"
                    placeholder="Digite um assunto..." :state="Boolean(assunto)" @blur="onBlurAssunto" rows="3"
                    max-rows="6"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12" md="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
                <b-form-group class="formGroup" id="comentario-textarea-group" label="Comentário"
                  label-for="textarea-Comentario" label-cols="auto" content-cols="12" v-if="rascunho">
                  <b-form-textarea v-if="rascunho" id="textarea-Comentario" v-model="comentario"
                    placeholder="Digite um comentário..." @blur="onBlurComentario" rows="8" max-rows="10">
                  </b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Anexos - Atos" v-if="rascunho">
            <b-row>
              <b-col>
                <b-button class="float-right mb-3" @click="abrirModalNovoAto()">
                  <font-awesome-icon icon="plus" class="mr-2" />
                  Anexar Ato
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12" md="12" lg="12" xl="12">
                <b-table id="table-atos" striped hover :items="atos" :fields="fieldsAtos" small show-empty
                  no-border-collapse>
                  <template #empty>
                    <span>Não foram encontrados dados.</span>
                  </template>
                  <template #emptyfiltered>
                    <span>Não foram encontrados dados.</span>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-dark">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong class="loading-text">Carregando...</strong>
                    </div>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <div class="actions-icons">
                      <BtnDownload :fazerDownload="downloadArquivo" texto="Baixar Ato" :parametros="row.item"
                        :key="row.item.IdArquivo" />
                      <b-link class="text-dark" @click="confirmarExclusaoAnexo(row.item)">
                        <font-awesome-icon icon="trash" />
                        <div style="font-size: 12px">Remover</div>
                      </b-link>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="Anexos - Multimídias" v-if="rascunho">
            <b-row>
              <b-col>
                <b-button class="float-right mb-3" @click="abrirModalNovoMultimidia()">
                  <font-awesome-icon icon="plus" class="mr-2" />
                  Anexar Multimídia
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col xs="12" md="12" lg="12" xl="12">
                <b-table id="table-multimidias" striped hover :items="multimidias" :fields="fieldsMultimidia" small
                  show-empty no-border-collapse>
                  <template #empty>
                    <span>Não foram encontrados dados.</span>
                  </template>
                  <template #emptyfiltered>
                    <span>Não foram encontrados dados.</span>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-dark">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong class="loading-text">Carregando...</strong>
                    </div>
                  </template>
                  <template v-slot:cell(actions)="row">
                    <div class="actions-icons">
                      <BtnDownload :fazerDownload="downloadArquivo" texto="Baixar Multimídia" :parametros="row.item"
                        :key="row.item.IdArquivo" />
                      <b-link class="text-dark" @click="confirmarExclusaoAnexo(row.item)">
                        <font-awesome-icon icon="trash" />
                        <div style="font-size: 12px">Remover</div>
                      </b-link>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-container>
    </b-card>

    <b-modal id="assinatura-modal" size="md" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop
      no-close-on-esc>
      <template #modal-header>
        <h5>Assinar Anexos</h5>
      </template>

      <b-row>
        <b-col cols="6" class="">
          <b-form-group id="input-group-type" label-size="md" label="Tipo" label-for="type">
            <b-form-select v-model="type">
              <b-form-select-option value="S" selected>Senha</b-form-select-option>
              <b-form-select-option value="T">Token</b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col cols="6" class="">
          <b-form-group v-if="type === 'S'" id="input-group-password" label-size="md" label="Senha"
            label-for="password">
            <b-form-input type="text" style="width: 0; height: 0; padding: 0; border: 0"></b-form-input>
            <b-form-input v-model="senha" type="password" autocomplete="new-password"></b-form-input>
          </b-form-group>
          <b-form-group v-else id="input-group-type" label-size="md" label="Certificado" label-for="type">
            <b-form-select v-model="thumbprint">
              <b-form-select-option value="0" disabled selected>Selecione</b-form-select-option>
              <b-form-select-option v-for="cert in certificados" :key="cert.thumbprint" :value="cert.thumbprint">
                {{ cert.subjectName }}
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <template v-slot:modal-footer="{ cancel }">
        <b-progress :value="curValueBar" :max="maxValueBar" v-if="maxValueBar" class="w-50"></b-progress>
        <b-button size="sm" :disabled="showLoading" variant="secondary" @click="confirmar()" class="w-25">
          <b-spinner v-if="showLoading" small />
          Confirmar
        </b-button>
        <b-button size="sm" variant="outline-secondary" :disabled="showLoading" @click="cancelarAssinatura(cancel)" class="w-20">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="upload-ato-modal" button-size="sm" centered header-bg-variant="secondary" header-text-variant="light"
      header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc>
      <template #modal-header>
        <h5>Anexar Ato</h5>
      </template>
      <b-form-file v-model="novoArquivo" :state="Boolean(novoArquivo)" accept=".pdf, .zip"
        placeholder="Escolha um arquivo..." class="mt-3"></b-form-file>

      <b-form-select id="select-tpAto" v-model="novoTipoAto" :state="Boolean(novoTipoAto)" :options="comboTiposAtos"
        class="mt-3">
      </b-form-select>

      <template #modal-footer>
        <b-button size="sm" @click="adicionarAto()" :disabled="novoArquivo === null || novoTipoAto === null">
          Adicionar
        </b-button>
        <b-button size="sm" variant="outline-secondary" @click="fecharModalNovoAto()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

    <b-modal id="upload-multimidia-modal" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop
      no-close-on-esc>
      <template #modal-header>
        <h5>Anexar Multimídia</h5>
      </template>
      <b-form-file v-model="novoArquivo" :state="Boolean(novoArquivo)" :accept="tiposMultimidia"
        placeholder="Escolha um arquivo..." class="mt-3">
      </b-form-file>

      <template #modal-footer>
        <b-button size="sm" @click="adicionarMultimidia()" :disabled="novoArquivo === null">
          Adicionar
        </b-button>
        <b-button size="sm" variant="outline-secondary" @click="fecharModalNovoMultimidia()">
          Cancelar
        </b-button>
      </template>
    </b-modal>

  </div>
</template>

<script lang="ts">
import BtnVoltar from "@/components/shared/BtnVoltar.vue";
import BtnDownload from "@/components/shared/btn-download.vue"
import DadosComunicacaoEletronica from "@/components/processo-eletronico/comunicacoes-eletronicas/DadosComunicacaoEletronica.vue"
import LacunaWebPKI from "web-pki";
import protocoloService from "@/services/processos-eletronicos/protocoloService";
import { store } from "@/store";
import { Vue, Component } from 'vue-property-decorator'
import { PropType } from "vue";
import { Notificacao } from "@/types/processo-eletronico/notificacao";
import { CertificadoDigital } from "@/types/certificado-digital";
import { ArquivoProtocolo } from "@/types/processo-eletronico/arquivo-protocolo";
import { NovoProtocoloEtce } from "@/types/processo-eletronico/novo-protocolo";
import { Rascunho } from "@/types/processo-eletronico/rascunho";
import { ResponsavelEtce } from "@/types/processo-eletronico/responsavel-etce";
import { TipoDocumento } from "@/types/processo-eletronico/tipo-documento";
import { SelectValue } from "@/types/select-value";
import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";
import { trackProtocoloMatomoEvent } from "@/utils/matomo";

const CompProps = Vue.extend({
  name: 'ResponderAComunicacaoEletronica',
  props: {
    notificacao: {
      type: Object as PropType<Notificacao>
    }
  },
  components: { BtnDownload, BtnVoltar, DadosComunicacaoEletronica },
})

@Component
export default class ResponderAComunicacaoEletronica extends CompProps {

  //default/screen data
  atos: ArquivoProtocolo[] = []
  comboTiposAtos: SelectValue[] = []
  fieldsAtos = [
    {
      key: "NomeArquivo",
      label: "Arquivo",
    },
    {
      key: "TpArqStr",
      label: "Tipo",
    },
    {
      key: "actions",
      label: "Ações",
      tdClass: ["align-middle", "col-actions"],
      thClass: "text-center",
    },
  ]
  fieldsMultimidia = [
    {
      key: "NomeArquivo",
      label: "Arquivo",
    },
    {
      key: "actions",
      label: "Ações",
      tdClass: ["align-middle", "col-actions"],
      thClass: "text-center",
    },
  ]
  tiposMultimidia = '.mp3, .mp4'
  valorDefaultTipoAto: SelectValue = { value: null, text: "SELECIONE UM TIPO", disabled: true }

  //user data
  assunto = ''
  comentario = ''
  flCompensacao = ''
  itemDelete: ArquivoProtocolo | null = null
  multimidias: ArquivoProtocolo[] = []
  novoArquivo: File | null = null
  novoTipoAto: string | null = null
  rascunho: Rascunho = {
    Assunto: '',
    Comentario: '',
    TmpArquivosProtocolo: []
  }
  responsavel: ResponsavelEtce = { Nome: '' }
  tiposAtos: TipoDocumento[]
  tipoDocSelecionado: TipoDocumento = { Cod: 0, Descricao: '' }
  ug: UnidadeGestoraResumida = { Codigo: '', Nome: '' }

  //modal assinatura
  type = 'S'
  showLoading = false
  senha = ''
  thumbprint = ''
  pki: any
  tokens: any[] = []
  certificados: CertificadoDigital[] = []
  //barra de progresso de assinatura
  curValueBar = 0
  maxValueBar: number | null = null
  novoProtocolo: NovoProtocoloEtce | null
  listarCertificados: any

  //computed
  get desabilitarBtnCadastrar(): boolean {
    return (
      this.rascunho.Assunto === '' ||
      this.assunto === '' ||
      !this.tipoDocSelecionado ||
      this.atos.length + this.multimidias.length === 0
    )
  }

  trackProtocoloEvent(action: string, name?: string): void {
    trackProtocoloMatomoEvent(action, name);
  }

  //methods
  /**
     * Carrego o tipo de documento 'resposta a comunicacao processual' (e atos correspondentes).
     * @since 20220505
     */
  async carregarTipos(): Promise<void> {
    const response = await protocoloService.listarTiposRespostaCP()
    if (response && response.data && response.data.codTipoDocumento) {
      //console.log('carregar tipos', response.data)
      this.tipoDocSelecionado = {
        Cod: response.data.codTipoDocumento,
        Descricao: "RESPOSTA A COMUNICAÇÃO PROCESSUAL"
      };
      this.tiposAtos = response.data.tiposAto
      this.comboTiposAtos = [
        { value: null, text: "SELECIONE UM TIPO", disabled: true },
        ...this.tiposAtos.map((t) => {
          return {
            value: t.Cod,
            text: t.Descricao,
          };
        }),
      ];
      this.atualizarTiposMultimidia(response.data.tiposArquivo)
    } else {
      if (response.data?.msg) this.$toast.error(response.data.msg);
      else this.$toast.error("Erro ao recuperar tipos de documentos");
      this.$router.push("/processo-eletronico/comunicacoes-eletronicas")
    }
  }
  atualizarTiposMultimidia(tipos: Array<any>): void {
    this.tiposMultimidia = tipos.map(t => '.' + t.Extensao.trim()).join(', ')
  }

  compareTexto(c1: string | null, c2: string | null): boolean {
    if (c1 === "") c1 = null;
    if (c2 === "") c2 = null;
    return (
      (c1 === null && c2 !== null) ||
      (c1 !== null && c2 === null) ||
      (c1 !== null &&
        c2 !== null &&
        c1.replace(/[^a-z0-9]/g, "") !== c2.replace(/[^a-z0-9]/g, ""))
    );
  }

  getAssuntoEComentario(): void {
    if (this.rascunho !== null) {
      this.assunto = this.rascunho.Assunto;
      this.comentario = this.rascunho.Comentario;
    }
  }

  async getRascunhoProtocolo(): Promise<string | null> {
    const data = new FormData();
    /* console.log(this.ug);
    console.log(this.notificacao); */
    data.append("codUg", this.ug.Codigo ?? '');
    data.append("codNotificacao", this.notificacao.Codigo);

    const response = await protocoloService.getRascunhoProtocolo(data);
    if (response && response.status === 200) {
      this.rascunho = response.data;
      return "rascunho_retomado";
    }

    if (response && response.status === 204) return "novo";

    if (response?.data?.msg) this.$toast.error(response.data.msg);
    else this.$toast.error("Erro ao recuperar dados");

    return null;
  }

  limparForm(): void {
    this.rascunho = {
      Assunto: '',
      Comentario: '',
      TmpArquivosProtocolo: []
    };
    this.carregarTipos();
    this.obterResponsavelUg();
    this.assunto = '';
    this.comentario = '';
    this.atos = [];
    this.multimidias = [];
    this.novoProtocolo = null;
    this.tokens = [];
    this.senha = "";
  }

  /**
   * Verifico se o rascunho está vazio
   */
  isRascunhoEmpty(): boolean {
    return (
      this.rascunho.Assunto === '' &&
      this.rascunho.Comentario === '' &&
      this.rascunho.TmpArquivosProtocolo.length === 0
    )

  }

  async obterResponsavelUg(): Promise<void> {
    const response = await protocoloService.obterResponsavelUgCP(
      this.ug.Codigo
    );
    if (response && response.status === 200) {
      this.responsavel = response.data;
    } else {
      if (response.data?.msg) this.$toast.error(response.data.msg);
      else this.$toast.error("Erro ao obter responsável da UG");
    }
  }

  async onBlurAssunto(): Promise<void> {
    if (this.compareTexto(this.assunto, this.rascunho?.Assunto || null))
      await this.salvarRascunho();
  }

  async onBlurComentario(): Promise<void> {
    if (this.compareTexto(this.comentario, this.rascunho?.Comentario || null))
      await this.salvarRascunho();
  }

  async salvarRascunho(): Promise<void> {
    const data = new FormData();
    data.append("codUg", this.ug.Codigo ?? '');
    data.append("tpDocumento", this.tipoDocSelecionado.Cod.toString());
    data.append("codNotificacao", this.notificacao.Codigo);
    if (this.assunto !== null) data.append("assunto", this.assunto);
    if (this.comentario !== null) data.append("comentario", this.comentario);
    if (this.flCompensacao) {
      data.append("flCompensacao", this.flCompensacao === "S" ? 'true' : 'false');
    }

    let response;
    try {
      response = await protocoloService.salvarRascunho(data);
    } catch (error) {
      this.trackProtocoloEvent("rascunho_erro", "falha_requisicao");
      throw error;
    }

    if (response && response.status === 200) {
      this.rascunho = response.data;
      this.trackProtocoloEvent("rascunho_salvo", "comunicacao");
      this.$toast.success("Salvando dados...");
    } else {
      let msg;
      if (response?.data?.msg) msg = response.data.msg;
      else msg = "Erro ao salvar dados";

      this.trackProtocoloEvent("rascunho_erro", "resposta_api");
      this.$toast.error(msg);
      throw new Error(msg);
    }
  }

  async removerRascunho(): Promise<void> {
    try {
      store.blockScreen = true
      this.trackProtocoloEvent("descarte_confirmado", "comunicacao");
      const data = new FormData()
      data.append("codUg", this.ug.Codigo ?? '')
      data.append("codNotificacao", this.notificacao.Codigo)
      const response = await protocoloService.removerRascunhoProtocolo(data)
      if (response && response.status === 200) {
        this.trackProtocoloEvent("descarte_sucesso", "comunicacao");
        this.limparForm();
      } else {
        this.trackProtocoloEvent("descarte_erro", "resposta_api");
        if (response?.data?.msg) this.$toast.error(response.data.msg)
        else this.$toast.error("Erro ao remover rascunho")
      }
    } catch (err) {
      this.trackProtocoloEvent("descarte_erro", "falha_requisicao");
      console.error('Falha ao remover rascunho: ', err)
      this.$toast.error("Erro ao remover rascunho")
    } finally {
      store.blockScreen = false
    }
  }

  //abas de anexos
  async downloadArquivo(arquivo): Promise<void> {
    const response = await protocoloService.downloadArquivoRascunho(
      arquivo.IdProtocolo,
      arquivo.IdArquivo
    );
    if (response && response.status == 200) {
      this.download(arquivo.NomeArquivo, response.data);
    } else {
      if (response && response.data) {
        let respText = JSON.parse(await response.data.text())
        this.$toast.error(respText.msg)
      }
      else this.$toast.error("Erro ao obter o arquivo");
    }
  }

  //não consegui chamar o mixin
  download(filename, content): void {
    var element = document.createElement('a');
    element.setAttribute('href', URL.createObjectURL(content));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }

  async adicionarAto(): Promise<void> {
    try {
      //Permitir apenas zip ou pdf
      if (this.novoArquivo === null || (
        !this.novoArquivo.name.toLowerCase().endsWith(".pdf") &&
        !this.novoArquivo.name.toLowerCase().endsWith(".zip")
      )) {
        throw `Arquivo "${this.novoArquivo?.name}" possui tipo inválido`;
      }
      await this.adicionarArquivo(false);
      await this.carregarAtosMultimidias();
      this.fecharModalNovoAto();
    } catch (e: any) {
      this.trackProtocoloEvent("anexo_adicao_erro", "ato");
      this.$toast.error(e);
    }
  }

  async adicionarArquivo(isMultimidia: boolean): Promise<void> {
    let tamMaximo = 10;
    if (!this.novoArquivo)
      throw 'Erro ao anexar arquivo'

    if (this.novoArquivo.name.toLowerCase().endsWith(".zip")) tamMaximo = 300;
    if (this.novoArquivo.size / 1024 / 1024 > tamMaximo)
      throw `Arquivo "${this.novoArquivo?.name}" excede o tamanho máximo permitido (${tamMaximo} MB)`;

    const data = new FormData();
    data.append("arquivo", this.novoArquivo);
    data.append("codUg", this.ug.Codigo ?? '');
    data.append("responderNotificacao", 'true');
    data.append("isMultimidia", String(isMultimidia));
    data.append("codNotificacao", this.notificacao.Codigo)
    if (!isMultimidia) data.append("tipoAto", String(this.novoTipoAto));
    const response = await protocoloService.uploadArquivo(data);
    if (response && response.status === 200) {
      this.rascunho = response.data;
      this.trackProtocoloEvent("anexo_adicionado", isMultimidia ? "multimidia" : "ato");
      this.$toast.success("Anexando arquivo...");
    } else {
      if (response?.data?.msg) throw response.data.msg;
      else throw "Erro ao anexar arquivo";
    }
  }
  async removerArquivo(): Promise<void> {
    const tipoAnexo = this.itemDelete?.TpArquivo === 99991 ? "multimidia" : "ato";
    try {
      store.blockScreen = true
      const data = new FormData();
      data.append("codUg", this.ug.Codigo ?? '');
      data.append("idArquivo", String(this.itemDelete?.IdArquivo));
      data.append("codNotificacao", this.notificacao.Codigo)
      const response = await protocoloService.removerArquivo(data);
      if (response && response.status === 200) {
        this.rascunho = response.data;
        await this.carregarAtosMultimidias();
        this.trackProtocoloEvent("anexo_removido", tipoAnexo);
        this.$toast.success("Removendo arquivo...");
      } else {
        this.trackProtocoloEvent("anexo_remocao_erro", tipoAnexo);
        if (response?.data?.msg) this.$toast.error(response.data.msg);
        else this.$toast.error("Não foi possível remover o arquivo");
      }
      this.itemDelete = {};
    } catch (err) {
      this.trackProtocoloEvent("anexo_remocao_erro", tipoAnexo);
      console.error('Falha ao remover arquivo: ', err)
      this.$toast.error("Não foi possível remover o arquivo")
    } finally {
      store.blockScreen = false
    }
  }
  carregarAtosMultimidias(): void {
    if (
      this.rascunho !== null &&
      this.rascunho.TmpArquivosProtocolo != null
    ) {
      this.atos = this.rascunho.TmpArquivosProtocolo.filter(
        (t) => t.TpArquivo !== 99991
      );
      this.atos.forEach((ato) => {
        ato.TpArqStr = this.tiposAtos?.find(
          (t) => t.Cod === ato.TpArquivo
        )?.Descricao ?? '';
      });
      this.multimidias = this.rascunho.TmpArquivosProtocolo.filter(
        (t) => t.TpArquivo === 99991
      );
    }
  }
  async adicionarMultimidia(): Promise<void> {
    try {
      if (!this.novoArquivo)
        throw 'Erro ao anexar multimídia'

      //Permitir apenas mp3 ou mp4
      const extensao = this.novoArquivo.name.substring(this.novoArquivo.name.lastIndexOf('.'))
      if (!this.tiposMultimidia.includes(extensao.toLowerCase())) {
        throw `Arquivo "${this.novoArquivo.name}" possui tipo inválido`;
      }
      await this.adicionarArquivo(true);
      await this.carregarAtosMultimidias();
      this.fecharModalNovoMultimidia();
    } catch (e: any) {
      this.trackProtocoloEvent("anexo_adicao_erro", "multimidia");
      this.$toast.error(e);
    }
  }

  //modal assinatura
  async assinarComSenha() {
    const data = new FormData();
    data.append("codUg", this.ug.Codigo ?? '');
    data.append("codNotificacao", this.notificacao.Codigo)
    data.append("senha", this.senha);
    const response = await protocoloService.assinarEnviarProtocolo(data);
    if (response && response.status === 200) {
      this.novoProtocolo = response.data;
      //this.$bvModal.hide('assinatura-modal');
    } else {
      if (response.data?.msg) throw response.data.msg;
      else throw "Erro salvando protocolo";
    }
  }

  limparProgressBar() {
    this.curValueBar = 0;
    this.maxValueBar = null;
  }

  async confirmar() {
    const data = new FormData();
    this.showLoading = true;
    const tipoAssinatura = this.type === "S" ? "senha" : "token";
    this.trackProtocoloEvent("cadastro_confirmado", tipoAssinatura);
    if (this.type == "S") {
      this.curValueBar = 1;
      this.maxValueBar = 3;
      try {
        await this.assinarComSenha();
        this.curValueBar = 2;
        this.$toast.success(
          `Protocolo ${this.novoProtocolo?.CodigoTCE} salvo com sucesso`
        );
        this.trackProtocoloEvent("cadastro_sucesso", "senha");
        this.limparForm();
        this.$router.push("/processo-eletronico/comunicacoes-eletronicas")
      } catch (e: any) {
        console.error("Erro ao confirmar assinatura com senha", e);
        this.trackProtocoloEvent("cadastro_erro", "senha");
        this.$toast.error(e);
      } finally {
        this.showLoading = false;
        this.$bvModal.hide("assinatura-modal");
        this.limparProgressBar();
      }
    } else {
      this.curValueBar = 1;
      this.maxValueBar = 50;
      try {
        await this.iniciarAssinaturaToken();
        this.maxValueBar = 4 + this.tokens.length;
        this.curValueBar++;
        this.preauthorizeSignatures();
      } catch (e: any) {
        this.trackProtocoloEvent("cadastro_erro", "token_inicio");
        this.$toast.error(e);
        this.showLoading = false;
        this.limparProgressBar();
      }
    }
  }

  //métodos de assinatura com restpki
  async completeSignature() {
    try {
      await this.finalizarAssinaturaToken();
      this.$toast.success(
        `Protocolo ${this.novoProtocolo?.CodigoTCE} salvo com sucesso`
      );
      this.trackProtocoloEvent("cadastro_sucesso", "token");
      this.limparForm();
      this.$router.push("/processo-eletronico/comunicacoes-eletronicas")
    } catch (e: any) {
      console.error("Erro ao completar assinatura com token", e);
      this.trackProtocoloEvent("cadastro_erro", "token_finalizacao");
      this.$toast.error(e);
    } finally {
      this.showLoading = false;
      this.$bvModal.hide("assinatura-modal");
      this.limparProgressBar();
    }
  }

  async finalizarAssinaturaToken() {
    let t = { codUg: this.ug.Codigo, sigTokens: this.tokens, codNotificacao: this.notificacao.Codigo };
    const response = await protocoloService.finalizarAssinaturaToken(t);
    if (response && response.status === 200) {
      this.novoProtocolo = response.data;
    } else {
      if (response.data?.msg) throw response.data.msg;
      else throw "Erro finalizando assinatura de anexos";
    }
  }

  async iniciarAssinaturaToken() {
    const data = new FormData();
    data.append("codUg", this.ug.Codigo ?? '');
    data.append("codNotificacao", this.notificacao.Codigo)
    const response = await protocoloService.iniciarAssinaturaToken(data);
    if (response && response.status === 200) {
      this.tokens = response.data;
    } else {
      if (response.data?.msg) throw response.data.msg;
      else throw "Erro iniciando assinatura de anexos";
    }
  }

  async preauthorizeSignatures() {
    this.pki
      .preauthorizeSignatures({
        certificateThumbprint: this.thumbprint,
        signatureCount: this.tokens.length, // number of signatures to be authorized by the user
      })
      .success(() => {
        this.curValueBar++;
        this.signAllWithRestPki(this.tokens.map((t) => t.Token));
      })
      .fail((err) => {
        console.error("Falha no pki.preauthorizeSignatures", err);
        this.trackProtocoloEvent("cadastro_erro", "token_pre_autorizacao");
        this.$toast.error(
          "Falha ao assinar digitalmente. O serviço de assinaturas parece estar offline. Por favor tente novamente em instantes.",
          {
            timeout: 9000,
          }
        );
        this.showLoading = false;
        this.limparProgressBar();
      });
  }

  signAllWithRestPki(tokens) {
    let currentToken = tokens.pop();
    this.pki
      .signWithRestPki({
        token: currentToken,
        thumbprint: this.thumbprint,
      })
      .success((res) => {
        this.curValueBar++;
        if (tokens.length > 0) this.signAllWithRestPki(tokens);
        else this.completeSignature();
      })
      .error((error) => {
        console.error("Falha no signAllWithRestPki", error);
        this.onWebPkiError("Erro ao assinar documento.", error, "token_assinatura");
        this.limparProgressBar();
      });
  }

  //métodos acessórios do restpki
  loadCertificates() {
    this.pki
      .listCertificates({
        filter: this.pki.filters.isWithinValidity,
      })
      .success((certs) => {
        this.certificados = certs;
        this.listarCertificados = setTimeout(() => {
          this.loadCertificates();
        }, 50000);
      });
  }

  onWebPkiNotInstalled(status, msg, arg3, arg4) {
    this.trackProtocoloEvent("cadastro_erro", "webpki_nao_instalado");
    this.$toast.error("Extensão WebPKI não encontrada");
  }

  onWebPkiFail(status, msg, arg3, arg4) {
    this.trackProtocoloEvent("cadastro_erro", "webpki_falha");
    this.$toast.error("Extensão WebPKI retornou uma falha.");
    this.limparProgressBar();
  }

  onWebPkiError(message, error, origin: string | null = null) {
    this.trackProtocoloEvent("cadastro_erro", origin || "webpki_erro");
    this.$toast.error("Ocorreu um erro ao executar o WebPKI.");
    this.showLoading = false;
    this.limparProgressBar();
  }


  //abrir e fechar modais, abas, accordions etc
  abrirModalAssinatura() {
    this.trackProtocoloEvent("cadastro_clicado", "formulario_valido");
    this.$bvModal.show("assinatura-modal");
  }
  cancelarAssinatura(cancel: () => void): void {
    this.trackProtocoloEvent("cadastro_cancelado", this.type === "S" ? "senha" : "token");
    cancel();
  }
  perguntarLimparRascunho() {
    this.trackProtocoloEvent("descarte_clicado", "comunicacao");
    this.$bvModal.msgBoxConfirm('Tem certeza que deseja descartar as alterações?', {
      buttonSize: 'sm',
      cancelTitle: 'Cancelar',
      cancelVariant: 'outline-secondary',
      centered: true,
      headerBgVariant: 'secondary',
      headerTextVariant: 'light',
      okTitle: 'Descartar',
      title: 'Confirmar exclusão',
    }).then(value => {
      if (value) this.removerRascunho()
      else this.trackProtocoloEvent("descarte_cancelado", "comunicacao");
    }).catch(err => {
      console.error('Erro no modal de limpeza de rascunho', err)
    })
  }
  abrirModalNovoAto() {
    this.$bvModal.show("upload-ato-modal");
  }
  fecharModalNovoAto() {
    this.$bvModal.hide("upload-ato-modal");
    this.novoTipoAto = null;
    this.novoArquivo = null;
  }
  confirmarExclusaoAnexo(item) {
    this.itemDelete = item
    this.$bvModal.msgBoxConfirm(`Tem certeza que deseja remover o arquivo ${this.itemDelete?.NomeArquivo}?`, {
      buttonSize: 'sm',
      cancelTitle: 'Cancelar',
      cancelVariant: 'outline-secondary',
      centered: true,
      headerBgVariant: 'secondary',
      headerTextVariant: 'light',
      okTitle: 'Excluir',
      title: 'Confirmar remoção',
    }).then(value => {
      if (value) this.removerArquivo()
    }).catch(err => {
      console.error('Erro no modal de remoção de anexo', err)
    })
  }
  abrirModalNovoMultimidia() {
    this.$bvModal.show("upload-multimidia-modal");
  }
  fecharModalNovoMultimidia() {
    this.$bvModal.hide("upload-multimidia-modal");
    this.novoArquivo = null;
  }
  /*navegarParaDetalhesComunicacaoEletronica() {
    this.$router.push({
      name: "detalhes-comunicacao-eletronica",
      params: { 'notificacao': this.notificacao },//isso aqui tem que rever?
    });
  }*/
  /*sleep(ms): Promise<void> {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }*/

  beforeDestroy() {
    if (this.listarCertificados) clearTimeout(this.listarCertificados);
  }

  async mounted() {
    try {
      store.blockScreen = true;
      this.ug = {
        Codigo: this.notificacao.CodUg,
        Nome: this.notificacao.UnidadeGestora,
      };
      this.trackProtocoloEvent("criacao_clicada", "comunicacao");
      const tipoCriacao = await this.getRascunhoProtocolo();
      this.trackProtocoloEvent(
        tipoCriacao ? "criacao_iniciada" : "criacao_erro",
        tipoCriacao || "rascunho_consulta"
      );
      this.getAssuntoEComentario();
      await this.obterResponsavelUg();
      await this.carregarTipos();
      await this.carregarAtosMultimidias();

      this.pki = new LacunaWebPKI(process.env.VUE_APP_LACUNA_LICENSE);
      this.pki.init({
        restPkiUrl: process.env.VUE_APP_REST_PKI_URL,
        ready: this.loadCertificates,
        notInstalled: this.onWebPkiNotInstalled,
        defaultFail: this.onWebPkiError,
      });

      await this.salvarRascunho();
    } finally {
      store.blockScreen = false;
    }
  }
}
</script>
<style scoped></style>
